import React from "react";

import SearchContents, {
    SearchContentsProps,
} from "./components/SearchContents/SearchContents";

import "./assets/styles/global.css";

function App(props: SearchContentsProps) {
    return <SearchContents {...props} />;
}

export default App;
